import { render, staticRenderFns } from "./asset-management-warnings-list.component.vue?vue&type=template&id=0e7bc771"
import script from "./asset-management-warnings-list.component.ts?vue&type=script&lang=ts&external"
export * from "./asset-management-warnings-list.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e7bc771')) {
      api.createRecord('0e7bc771', component.options)
    } else {
      api.reload('0e7bc771', component.options)
    }
    module.hot.accept("./asset-management-warnings-list.component.vue?vue&type=template&id=0e7bc771", function () {
      api.rerender('0e7bc771', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/warnings-list/asset-management-warnings-list.component.vue"
export default component.exports